export function configLabelFromAutocompleteValue(selectOnly: boolean, value: string | null): string {
  if (selectOnly) return (value ?? '').trim();
  return (value ?? 'default').trim() || 'default';
}
